/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

var LOG = require('logger').getLogger('login');

var $ = require('base'), layer = $.Deferred(), qtip2 = $.Deferred(), model = $.Deferred(), cache = $.Deferred();

// 图片校验码
$('#img_val_code_refresh').off('click').on('click', refreshCode);
// 刷新图片
function refreshCode() {
	var objImg = document.getElementById('imgValidCode');
	objImg.src = '/getSecurityCode.htm?c=4&s=18&l=3&t=' + new Date().getTime();
}

require.ensure('layer', function () {
	var _layer = require('layer'), ori_done = layer.done;
	layer.done = function (fn, ctx) {
		ori_done($.proxy(fn, ctx, _layer));
	}
	layer.resolve(_layer);
})

require.ensure('qtip2', function () {
	var _qtip2 = require('qtip2'), ori_done = qtip2.done;
	qtip2.done = function (fn, ctx) {
		ori_done($.proxy(fn, ctx, _qtip2));
	}
	qtip2.resolve(_qtip2);
})

require.ensure('model', function () {
	var model_factory = require('model'), ori_done = model.done;
	model.done = function (fn, ctx) {
		ori_done($.proxy(fn, ctx, model_factory));
	}
	model.resolve(model_factory);
})

require.ensure('cache', function () {
	var cache_manager = require('cache'), ori_done = cache.done;
	cache.done = function (fn, ctx) {
		ori_done($.proxy(fn, ctx, cache_manager));
	}
	cache.resolve(cache_manager);
})

// 自动填充用户名
cache.done(function(cache_manager){
	var account = cache_manager.get('account', cache_manager.levels.LOCAL_STORAGE );
	$('input[data-prop-path="account"]').val(account);
})

qtip2.done(function(){
    console.log($('input[data-tip]'))
    $('input[data-tip]').each(function () {
		var that = $(this);
		var tip_options = new Function("return " + that.data('tip'))();
		var events = $.map(tip_options, function (t, e) {
				return e;
			})
			that.qtip({
				content : function (e, api) {
					$(this).focus().select();
					return tip_options[e.type] || e.content;
				},
				show : events.join(' ') + ' error',
				hide : 'keydown blur',
				position : {
					viewport : $(window),
					target : (tip_options['target'] && $(tip_options['target'])) || true,
					my : 'left center',
					at : 'right center',
				},
				style : 'input_tip1'
			})
	})

	// 所有的input且有data-tip的不允许输入空格
	$('input[data-tip]').off('keyup').on('keyup', function (e) {
		var self = $(this);
		var value = self.val();
		if (/\s+/.test(value)) {
			self.trigger({
				type : 'error',
				content : '输入空格无效'
			});
			value = value.replace(/\s+/, '', 'g');
			self.val(value);
			return;
		} else if (e.keyCode === 13) {
			_doLogin();
		}
	})
})
console.log($('#login_btn'))
$(document).on('click','#login_btn',function(){
	_doLogin();
	return false;
})

/*
 * 后台登陆.
 */
function _doLogin() {
	model.done(function (model_factory) {
		var member = model_factory.build_model($('form'));
		var el_account = $('input[data-prop-path="account"]'),
		account = member.account,
		el_pwd = $('input[data-prop-path="password"]'),
		pwd = member.password,
		securityCode = member.securityCode;
		delete member.securityCode;
		if (!account ? el_account.trigger('require') && false : (!pwd ? el_pwd.trigger('require') && false : true) === true) {
			if ($("#divLogin").is(':visible') && !securityCode) {
				$("#securityCode").trigger('require');
				return false;
			}
			$.ajax({
				url : '/onLogin.htm?securityCode=' + (securityCode || ''),
				type : 'post',
				contentType : 'application/json',
				data : JSON.stringify(member),
				success : function (tip) {
					//console.log(tip);
					if (tip.result === 'success') {
						cache.done(function(cache_manager){
							// 如果是记住用户名
							if ($('#remenber').is(':checked')) {
								cache_manager.set('account', member.account, cache_manager.levels.LOCAL_STORAGE)
							} else {
								cache_manager.remove('account', cache_manager.levels.LOCAL_STORAGE)
							}
						})
						layer.done(function (layer) {
							layer.msg('登陆成功', {
								icon : 1,
								time : 1000,
								closeBtn : 0,
								shade : [0.8, '#393D49'],
								shadeClose : true,
							}, function (index) {
								LOG.info('恭喜您登陆成功.');
								window.location.href = '/member_center_home.htm'
							})
						})
					} else if (tip.result === 'val_code_error') {
						$("#securityCode").trigger({
							type : 'error',
							content : '验证码不正确'
						});
						refreshCode();
					} else if(tip.result === 'fail') {
						layer.done(function (layer) {
							layer.msg('账号或密码不正确.', {
								title : '温馨提示',
								icon : 5,
								closeBtn : 1,
								shade : [0.8, '#393D49'],
								shadeClose : true
							}, function (index) {
								layer.close(index);
								//$("#divLogin").removeClass('test_box');
								$("#divLogin").css("display","block");
							})
						})
					}
				}
			})
		}
	})
}
module.exports = _doLogin
require('../css/memberIndex/login.less');
require('../css/bootstrap.css');
require('../css/login/pocketgrid.min.css');
require('../css/layer.css');
require('../css/jquery.qtip.min.css')





// WEBPACK FOOTER //
// ./src/main/javascript/memberIndex/com.jufeng.member.login.js